import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import {
  ApexAxisChartSeries,
  ApexChart,
  ApexPlotOptions,
  ApexXAxis,
  ApexDataLabels,
  ApexTooltip,
  ApexResponsive
} from 'ng-apexcharts';
import { InsucessosQualificados } from '../interfaces/insucessos-qualificados';

@Component({
  selector: 'app-Insucesso-leads-qualificados',
  templateUrl: './Insucesso-leads-qualificados.component.html',
  styleUrls: ['./Insucesso-leads-qualificados.component.css']
})
export class InsucessoLeadsQualificadosComponent implements OnInit {

  public chartOptions: Partial<{
    series: ApexAxisChartSeries;
    chart: ApexChart;
    plotOptions: ApexPlotOptions;
    xaxis: ApexXAxis;
    dataLabels: ApexDataLabels;
    tooltip: ApexTooltip;
    responsive: ApexResponsive[];
  }>;

  @Input() insucesso: InsucessosQualificados;

  constructor() { }

  ngOnInit() {
    this.inicializarGrafico();
  }

  ngOnChanges(changes: SimpleChanges): void {
      if (changes['insucesso'] && changes['insucesso'].currentValue) {
        this.inicializarGrafico();
      }
    }

  private inicializarGrafico(): void {
  const valores = this.insucesso.motivos.map(m => m.valor);
  const labels = this.insucesso.motivos.map(m => m.label);

  const quantidadeCategorias = this.insucesso.motivos.length;
  const alturaPorLinha = 30;
  const alturaTotal = quantidadeCategorias * alturaPorLinha;
  const total = this.insucesso.total || 1;

  this.chartOptions = {
    series: [
      {
        name: 'Motivos',
        data: valores
      }
    ],
    chart: {
      type: 'bar',
      height: alturaTotal,
      toolbar: { show: false }
    },
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: '50%'
      }
    },
    tooltip: {
      y: {
        formatter: (val: number) => {
          const percent = ((val / total) * 100).toFixed(1);
          return `${val} (${percent}%)`;
        }
      }
    },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: '12px'
      }
    },
    xaxis: {
      categories: labels,
      tickAmount: 4, // Reduz marcações para evitar sobreposição
      labels: {
        style: {
          fontSize: '11px'
        }
      }
    },
    responsive: [
      {
        breakpoint: 768,
        options: {
          chart: {
            height: quantidadeCategorias * 50
          },
          plotOptions: {
            bar: {
              barHeight: '45%'
            }
          },
          xaxis: {
            tickAmount: 3,
            labels: {
              style: {
                fontSize: '10px'
              }
            }
          },
          dataLabels: {
            style: {
              fontSize: '10px'
            }
          }
        }
      }
    ]
  };
}


}
